import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FrontendRoutes } from '@helpers/Constants/Navigation';

interface OrderBreadcrumbProps {
  steps: string[];
  activeItem: string;
  customerName?: string;
  customerId?: number;
}

export const OrderBreadcrumb: React.FC<OrderBreadcrumbProps> = ({
  steps,
  activeItem,
  customerName,
  customerId,
}) => {
  const navigate = useNavigate();
  //if steps array contains 'customer_name' placeholder, replace it with the actual customer name
  const updatedSteps = steps.map((step) => {
    return step === 'customer_name' ? customerName : step;
  });
  const activeIndex = updatedSteps.indexOf(activeItem);
  const visibleSteps =
    activeIndex !== -1
      ? updatedSteps.slice(0, activeIndex + 1)
      : [updatedSteps[0]];

  // Map step name to route
  const getStepRoute = (step: string, id?: number) => {
    switch (step) {
      case 'Customers':
        return FrontendRoutes.CUSTOMER_LIST;
      case customerName:
      case 'customer_name':
        return FrontendRoutes.CUSTOMER_DETAILS.replace(
          ':customerId',
          String(id),
        ); // You may want to pass the actual customerId if available
      case 'New Order':
        return FrontendRoutes.CREATE_ORDER_SPECIES_SELECTION;
      case 'Order Summary':
        return FrontendRoutes.CREATE_ORDER_SUMMARY;
      default:
        return undefined;
    }
  };

  return (
    <div className="main">
      <ol className="inline-flex p-0 m-0 relative w-full border-t border-b border-solid border-[#bababa] h-10">
        {visibleSteps.map((item, index) => (
          <li
            key={index}
            className={`flex text-gray-500 relative p-0 m-0 text-center ${
              item === activeItem ? 'bg-[#ffffff] text-black' : 'bg-white'
            } hover:bg-[#fffff] hover:cursor-pointer h-[38px]`}
          >
            <button
              type="button"
              className={`relative leading-[40px] h-full w-full text-center inline-flex justify-center items-center ml-2 ${
                index !== visibleSteps.length - 1 ? '' : 'text-black'
              } ${item === activeItem ? 'text-[#1D1B20]' : 'text-[#919192]'}`}
              disabled={item === activeItem}
              onClick={() => {
                const route = getStepRoute(item as string, customerId);
                if (route && item !== activeItem) navigate(route as string);
              }}
            >
              {index === 0 && (
                <svg
                  width="12"
                  height="16"
                  viewBox="0 0 12 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="inline-block mr-2"
                >
                  <path
                    d="M6.00806 9.85952C6.37917 9.85952 6.6929 9.7317 6.94926 9.47606C7.20562 9.22027 7.33379 8.91122 7.33379 8.54889C7.33379 8.18641 7.2037 7.87997 6.9435 7.62958C6.68331 7.37919 6.36682 7.25399 5.99402 7.25399C5.62444 7.25399 5.31078 7.38106 5.05304 7.6352C4.79515 7.88934 4.66621 8.19847 4.66621 8.5626C4.66621 8.92358 4.79707 9.22994 5.0588 9.48168C5.32068 9.73357 5.6371 9.85952 6.00806 9.85952ZM3.00932 12.7287H8.99068V12.2679C8.99068 11.9963 8.91581 11.7625 8.76608 11.5666C8.61635 11.3709 8.41951 11.2174 8.17558 11.1061C7.84451 10.9535 7.49304 10.8415 7.12116 10.7698C6.74913 10.6984 6.37518 10.6626 5.99931 10.6626C5.62329 10.6626 5.24949 10.6984 4.87792 10.7698C4.50635 10.8415 4.15518 10.9535 3.82442 11.1061C3.58049 11.2174 3.38365 11.3709 3.23392 11.5666C3.08419 11.7625 3.00932 11.9963 3.00932 12.2679V12.7287ZM10.614 16H1.37867C0.993902 16 0.667971 15.8684 0.400874 15.6053C0.133625 15.342 0 15.0227 0 14.6473V1.35266C0 0.977298 0.134775 0.657975 0.404326 0.394695C0.673724 0.131565 1.00096 0 1.38603 0H7.96019L12 3.94718V14.6469C12 15.0226 11.8651 15.342 11.5954 15.6053C11.3257 15.8684 10.9986 16 10.614 16Z"
                    fill="currentColor"
                    fillOpacity="0.75"
                  />
                </svg>
              )}
              <span className="mr-2">{item}</span>
              <div className="relative inline-block">
                {/* > svg - added between the steps */}
                {index !== visibleSteps.length - 1 && (
                  <svg
                    width="13"
                    height="42"
                    viewBox="0 0 13 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <line
                      x1="0.5"
                      y1="-0.5"
                      x2="23.1468"
                      y2="-0.5"
                      transform="matrix(0.497696 0.867352 -0.325611 0.945504 0.769531 1)"
                      stroke="#B7B7B7"
                      strokeLinecap="round"
                    />
                    <line
                      x1="0.5"
                      y1="-0.5"
                      x2="23.1467"
                      y2="-0.5"
                      transform="matrix(0.497746 -0.867323 -0.32565 -0.94549 0.769531 41)"
                      stroke="#B7B7B7"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </div>
            </button>
          </li>
        ))}
      </ol>
    </div>
  );
};
